/**
 * Filtra sucursales por término de búsqueda
 * @param {Array} branches - Lista de sucursales
 * @param {string} searchTerm - Término de búsqueda
 * @returns {Array} - Sucursales filtradas
 */
export const filterBranches = (branches, searchTerm) => {
  if (!searchTerm.trim()) {
    return branches;
  }

  const term = searchTerm.toLowerCase();
  return branches.filter(
    (branch) =>
      branch.description?.toLowerCase().includes(term) ||
      branch.name?.toLowerCase().includes(term) ||
      branch.adress?.toLowerCase().includes(term) ||
      branch.city?.toLowerCase().includes(term) ||
      branch.province?.toLowerCase().includes(term) ||
      branch.email?.toLowerCase().includes(term)
  );
};

/**
 * Valida un email
 * @param {string} email - Email a validar
 * @returns {boolean} - True si es válido
 */
export const validateEmail = (email) => {
  if (!email) return true; // Email es opcional
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};

/**
 * Valida un teléfono
 * @param {string} phone - Teléfono a validar
 * @returns {boolean} - True si es válido
 */
export const validatePhone = (phone) => {
  if (!phone) return true; // Teléfono es opcional
  const cleanPhone = phone.replace(/\D/g, '');
  return cleanPhone.length >= 8 && cleanPhone.length <= 15;
};

/**
 * Valida el código postal
 * @param {string} postalCode - Código postal a validar
 * @returns {boolean} - True si es válido
 */
export const validatePostalCode = (postalCode) => {
  if (!postalCode) return true; // Código postal es opcional
  const cleanCode = postalCode.replace(/\D/g, '');
  return cleanCode.length >= 3 && cleanCode.length <= 10;
};

/**
 * Normaliza un string removiendo acentos y convirtiendo a minúsculas
 * @param {string} str - String a normalizar
 * @returns {string} - String normalizado
 */
export const normalizeString = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

/**
 * Prepara los datos de la sucursal para envío a la API
 * @param {Object} branch - Datos de la sucursal
 * @returns {Object} - Datos preparados para la API
 */
export const prepareBranchData = (branch) => {
  const cleanedData = { ...branch };

  // Limpiar campos vacíos
  Object.keys(cleanedData).forEach((key) => {
    if (cleanedData[key] === '' || cleanedData[key] === null) {
      delete cleanedData[key];
    }
  });

  return cleanedData;
};
